/*
 * @Author: Sam
 * @Date: 2020-10-12 15:23:33
 * @LastEditTime: 2023-11-30 11:59:40
 * @LastEditors: Vincent.Zhu
 * @Description:
 * @FilePath: \resourcesf:\thework\tofba-client\src\lang\zh.js
 * @可以输入预定的版权声明、个性签名、空行等
 */
export default {
  route: {
    // 九方
    waybillManagement: '运单',
    abroadWaybill: '海外仓',
    endWaybill: '清提派',
    smallParcelWaybill: '小包',
    systemHelp: '帮助',
    myProfile: '我的',
    financialManagement: '财务',
    freightInquiry: '查价',
    systemInformation: '消息',
    waybillList: '运单列表',
    waybillDetails: '运单详情',
    orderToAirFreight: '空运下单',
    batchOrder: '批量下单',
    orderToSeaFreight: '海运下单',
    orderToExpressDelivery: '快递下单',
    pickupInformation: '提货信息',
    bookingDelivery: '预约送仓信息',
    addAirSeag2gwaybill: 'B2B下单',
    orderToBatch: '批量下单',
    abroadWaybillList: '海外仓运单列表',
    abroadWaybillEdit: '海外仓运单编辑',
    pendingWaybill: '待确认运单',
    orderToAbroadWaybill: '海外仓下单',
    endWaybillList: '运单列表',
    endOrderToAirFreight: '空运下单',
    endOrderToShipping: '海运下单',
    waybillHdDetail: '运单详情',
    smallParcelDraftList: '草稿箱',
    smallParcelProblemList: '问题件',
    customerProfileEmailNotification: '客户文件邮件通知',
    manageOtherFiles: '管理其他文件',
    teapplixOauth: 'Teapplix授权',
    mabangOauth: '马帮授权',
    ecCangOauth: '易仓授权',
    apiAuthorization: 'API信息',
    importerInformation: '常用进口商',
    overseasWarehouseTrackingNotificationSettings: '海外仓轨迹通知设置',
    pickupAddress: '常用提货地址',
    senderInformation: '常用发件人',
    shippingAddress: '常用派送地址',
    invoiceTitle: '发票抬头',
    skuInfo: 'SKU管理',
    storeManagement: '亚马逊店铺管理',
    trackingNotificationSettings: '轨迹通知设置',
    flowRecord: '流水记录',
    quickRepayment: '快速还款',
    freightCalculation: '运费试算',
    contactUs: '联系我们',
    quickOrderGuidance: 'FBA快捷下单指引',
    OMS: 'OMS',
    amazon: '亚马逊',
    inbound: '创建亚马逊发货计划',
    planlist: '亚马逊入库发货计划列表',
    amazonCreateOrder: '物流服务商下单',
    //
    dashboard: '首页',
    historyPrice: '历史价格表',
    quotationList: '报价表',
    file: '我的文件',
    billException: '账单异常',
    warehouseInfoMaintenance: '第三方仓库信息维护',
    stdEnquiry: 'STD询价',
    enquiry: '在线询价',
    savedEnquiryOrder: '已保存询价',
    enquiryOrder: '已下单询价',
    loseEnquiryOrder: '已失效询价',
    stdWaybillList: 'STD运单列表',
    stdWaybillDetail: 'STD运单详情',
    stdWaybillOrder: 'STD下单',
    stdBill: '账单列表',
    stdContactWay: '我的联系方式',
    stdCoupon: '优惠券',
    enterpriseAuth: '账号认证',
    sendWaybillDetail: 'Send运单详情',
  },
  navbar: {
    logOut: '退出登录',
    password: '修改密码',
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！',
  },
  dashboard: {
    waybillSummary: '运单汇总',
    financialCenter: '财务中心',
    newsCenter: '新闻中心',
    waybillList: '运单列表',
    fastRepayment: '快速还款',
    balance: '当前余额',
    amountOwed: '欠款金额',
    accountMnager: '客户经理',
    saleAssistantName: '客户助理',
    serviceManager: '客服经理',
    website: '官网',
    financialServices: '金融服务',
    abroadSystem: '九方海外仓',
    index: '序号',
    waybillNo: '运单号',
    referenceNo: '参考号',
    status: '状态',
    operate: '操作',
    partner: '合作伙伴',
    bill_tips: '起运港账单状态,灰色未出账单;绿色已出账单',
    dashboard_tips:
      '跨境收款费率0至0.3%,蚂蚁集团旗下17年跨境支付品牌,安全放心.',
    wanlihui: '万里汇',
    search_content: '请输入内容',
    waybill_no_required: '请输入运单号',
    reference_no_required: '请输入参考号',
  },
  waybill: {
    waybillAll: '全部',
    waitForConfirm: '待确认',
    waitForDealSend: '待交寄',
    waitForOutStock: '待出库',
    waitForToThePort: '待到港',
    waitForSign: '待签收',
    alrSeadySigned: '已签收',
    alrSeadyReturned: '已退货',
    problematic: '问题件',
    already_close: '已关闭',
    wait_for_confirm: '待确认',
    wait_for_deal_send: '待交寄',
    wait_for_in_stock: '待入库',
    wait_for_out_stock: '待出库',
    wait_for_on_line: '待上网',
    wait_for_depart: '卡航待发车',
    ka_tie_wait_for_depart: '卡铁待发车',
    wait_for_clearance_of_goods: '待报关',
    customs_inspecting: '报关检查中',
    wait_for_permitthrough: '待报关放行',
    wait_for_leaveport: '待离港',
    wait_for_arrivalport: '待到港',
    wait_for_cclearance: '待清关(待申报)',
    cclearance_inspecting: '清关查验中',
    wait_for_clearancerelease: '待清关放行',
    wait_carry_cabinet: '待提柜',
    wait_for_arrivalstock: '待到仓',
    wait_for_dispatch: '待派送',
    part_of_sign: '部分签收',
    wait_for_sign: '待签收',
    wait_for_lock: '待锁单',
    already_finish: '已完成',
    already_freeze: '冻结',
    already_returned: '已退货',
    discharging_port: '卸货港',
    unload_a_ship: '卸船',
    __sea__: '海运',
    __air__: '空运',
    __seaandair__: '海运+空运',
    quickOrder: 'FBA快捷下单',
    fastOrder: '便捷下单',
    standardOrder: '标准下单',
    upExcelTitle: '上传入库计划装箱单',
    selectChannel: '渠道选择',
    selectSender: '选择发件人',
    selectImporter: '选择进口商',
    customsClearanceInvoice: '清关发票',
    customsClearanceInvoiceTips:
      '请注意采购单价币种与申报币种不一致，采购单价为我司投保和理赔的实际依据，请谨慎填写',
    ThePackingList: '装箱单',
    loadingPort: '起运地',
    customer: '客户',
    customer_info: '客户信息',
    customer_hope: '潜在客户',
    country_not_null: '国家不能为空',
    customer_importer_attn_not_null: '联系人不能为空',
    customer_importer_phone_not_null: '联系方式不能为空',
    address_not_null: '地址不能为空',
    address_not_contain_chinese: '地址不能输入中文',
    vat_not_null: 'VAT不能为空',
    vat_exists: 'VAT已存在',
    eori_exists: 'EORI已存在',
    link_man_not_null: '联系人不能为空',
    contact_way_not_null: '联系方式不能为空',
    default_value_not_null: '是否默认不能为空',
    state_value_not_null: '省份不能为空',
    city_not_null: '城市不能为空',
    area_not_null: '区县不能为空',
    zip_code_not_null: '邮编不能为空',
    customer_login_name_exists: '客户登录名已经存在, 请更换',
    customer_regist_phone_exists: '客户注册手机号已经存在, 请更换',
    customer_name_short_exists: '客户简称已经存在, 请更换',
    customer_name_full_exists: '客户全称已经存在, 请更换',
    customer_enterprise_creditcode_exists: '企业信用代码已经存在, 请更换',
    customer_delivery_company_not_null: '公司名称不能为空',
    customer_delivery_address_attn_not_null: '联系人不能为空',
    customer_delivery_address_phone_not_null: '联系电话不能为空',
    customer_delivery_address_not_null: '地址不能为空',
    customer_delivery_city_not_null: '城市不能为空',
    customer_delivery_state_not_null: '州省不能为空',
    customer_delivery_country_not_null: '州省不能为空',
    customer_delivery_zipcode_not_null: '邮编不能为空',
    customer_not_contain_chinese: '公司名称不能输入中文',
    sku_exists: 'SKU已存在',
    sku_not_null: 'SKU不能为空',
    declare_namecn_not_null: '中文品名不能为空',
    declare_nameen_not_null: '英文品名不能为空',
    brand_not_null: '品牌不能为空',
    material_not_null: '材质不能为空',
    purpose_not_null: '用途不能为空',
    customsCode_not_null: '海关编码不能为空',
    declareValue_not_null: '申报货值不能为空',
    purchasing_price_not_null: '采购单价不能为空',
    measurement_unit_not_null: '单位不能为空',
    business_license_picurl_must_upload: '提示营业执照需要上传',
    finance_email_must_input: '财务联系人邮箱必填, 多个邮箱; 分割',
    password_connot_equl_loginname: '密码不能和登录名一致',
    bt_mess_update_airshippingerrorrange: '批量修改空运误差范围',
    bt_mess_update_oceanshippingerrorrange: '批量修改海运误差范围',
    bt_mess_export_all_customerinfo: '导出客户完整版',
    bt_mess_export_customerinfo: '导出客户',
    upload_customer_sku_excel_poi_error: 'POI解析上传excel模板发生异常',
    excel_template_no_data: 'excel模板无数据',
    template_data_illegal_please_make_sure_each_sku_has_pic:
      '模板数据非法, 请确保每个SKU都有对应图片或者请勿重叠SKU图片坐标',
    save_fail: '保存失败',
    save_success: '保存成功',
    customer_sku_infos_collection_is_empty: '待更新SKU信息集合为空',
    sku_can_not_blank: 'SKU不允许为空',
    sku_is_repeat_in_this_template: 'SKU模板中重复',
    sku_is_repeat_in_database: 'SKU模板数据库中重复',
    sku_declare_name_en_is_blank: 'SKU英文品名为空',
    sku_declare_name_cn_is_blank: 'SKU中文品名为空',
    sku_brand_is_blank: 'SKU品牌为空',
    sku_material_is_blank: 'SKU材质为空',
    sku_purpose_is_blank: 'SKU用途为空',
    sku_customs_code_is_blank: 'SKU海关编码为空',
    sku_declare_value_is_blank: 'SKU申报货直为空',
    sku_purchasing_price_is_blank: 'SKU采购单价为空',
    sku_is_charged_is_blank: 'SKU是否带电为空',
    measurement_unit_blank_tips: '请填写SKU单位',
    measurement_unit_error: 'SKU单位填写有误, 只允许个或者套',
    per_suit_num_tips: '单位为套, 每套个数必填',
    customer_no_data: '客户无数据',
    user_id_not_null: '用户ID不能为空',
    invoice_name_not_null: '发票抬头名称不能为空',
    invoice_type_not_null: '抬头类型不能为空',
    invi_identifica_number_not_null: '纳税人识别号不能为空',
    is_default_not_null: '是否默认不能为空',
    invoice_receive_phone_format_error: '通知人手机号格式错误',
    invoice_receive_email_format_error: '通知人邮箱格式错误',
    email_exist: '邮箱已经存在',
    email_not_null: '邮箱不能为空',
    each_customer_only_can_create_ten_email: '每个客户最多允许创建10个邮箱',
    print_label_fail: '打印标签失败',
    box_no_is_not_exit: '箱号不存在',
    export_track_number: '导出追踪号',
    order_label_not_exit: '该订单还未获取过追踪标签',
    batch_send_confirm: '批量交寄',
    batch_return: '批量打回待确认',
    combined_customs_declaration: '合并报关',
    cancel_combined_customs_declaration: '取消合并报关',
    batch_print_label: '批量打印运单标签',
    batch_print_label_tips: '请选择预览打印的方式(A4纸每页打印6个标签)',
    cancel_abroad_waybillNo: '取消中转下单',
    abroad_waybill_create: '中转下单',
    bill_tips: '起运港账单状态,灰色未出账单;绿色已出账单',
    pva_tips: '是否清关递延变量,灰色否，黑色是',
    merge_declaration_tips: '合并报关单',
    detail: '详情',
    copy: '复制',
    download_packinglist: '下载已上传装箱单',
    download_packingfp: '下载箱单发票',
    download_fast_model: '下载下单核对资料',
    download_tracking_number: '下载箱单跟踪号',
    print_preview_tips: '打印预览',
    colReturn: '打回待确认',
    uploadCustomsInfo: '上传报关资料',
    uploadCDA: '上传CDA资料',
    inbound_data: '入库单',
    download_tips:
      '已为您打开文件下载页面，如果页面未跳转，请检查弹出窗口是否被浏览器拦截',
    transfer_cancel_aborad_waybill_tips: '是否取消中转下单',
    transfer_aborad_waybill_tips: '是否中转下单',
    boxNo: '外箱号',
    trackNumber: '追踪号',
    weight: '重量',
    length: '长',
    width: '宽',
    height: '高',
    instockCustomerWeight: '重量',
    instockCustomerLength: '长',
    instockCustomerWidth: '宽',
    instockCustomerHeight: '高',
    totalVolum: '体积',
    volumeWeight: '体积重',
    chargedWeight: '计费重',
    summary: '合计',

    invoice_tips: '请注意采购单价币种与申报币种不一致',
    import_invoice_tips: '批量导入箱单发票',
    restore_invoice_tips: '该功能只能恢复当前电脑的最近一次发票数据。',
    restoreInvoiceData: '恢复发票内容',
    showSkuList: ' 选择SKU',
    upLoadImg: '批量上传SKU图片',
    bulk_upload_price_screenshots: '批量上传售价截图',
    batch_upload_screenshots_of_earnings: '批量上传收益截图',
    resetInvoice: '重置发票内容',
    declareValueCurrency: '申报币种',
    purchaseValueCurrency: '采购币种',
    addEmptyData: '添加品名',
    uploadInvoice: '批量导入箱单发票',
    fba_template: '下载导入模板(适合FBA下单)',
    no_fba_template: '下载导入模板(适合非FBA下单)',
    fbc_template: '下载导入模板(适合FBC下单)',
    sku_same_template: '下载导入模板(适合非FBA，sku同款下单)',
    japan_line_template: '下载导入模板(适合日本线下单)',
    quick_template: '下载导入模板(便捷下单（箱单发票）)',
    quick_template_japan: '下载导入模板(便捷下单箱单发票-日本线)',
    import_invoice: '下载导入箱单发票模板',
    import_invoice_japan: '下载导入箱单发票模板(日本线)',
    upload_invoice_tips1:
      '有新模板导入若多个SKU箱号相同，箱号，长，宽，高，重列请合并单元格；',
    upload_invoice_tips2:
      '上传时请仔细检查模板数据,FBA需要填写Shipment ID，Reference ID；',
    upload_invoice_tips3: '如果系统收入客户SKU信息，会自动补全部分缺损部分',
    upload_invoice_text1: '将文件拖到此处，或',
    upload_invoice_text2: '点击上传',
    upload_invoice_text3: '支持多文件同时上传',
    upload_invoice_text4:
      '请您及时上传报关资料，如果不及时上传，系统会做扣货处理。',
    upload_server: '上传到服务器',
    quickOrderGuidance:
      '请直接上传从亚马逊卖家后台导出的发货计划表（EXCEL格式）。一键上传，自动完成发票和装箱单填写。如有疑问，请',
    blank: '点击此处',
    uploadExcel: '请上传EXCEL',
    continue_upload: '继续上传',
    select_file: '选择文件',
    upload_order_template: '上传单票下单模板',
    download_order_template: '单票导入模板',
    download_order_template_new: '单票导入模板(新)',
    download_batch_order_template: '下载批量下单模板',
    wait_return_cabinet: '待还柜',
    declaration_tips:
      '报关状态,灰色为不报关;绿色为报关且上传了报关资料，红色为报关未上传报关资料',
    wait_unloading_cabinet: '待卸柜',
    merge_customs_clearance: '合并清关',
    cancel_merge_customs_clearance: '取消合并清关',
    customs_information: '报关资料',
    batch_download_xdfp: '批量下载箱单发票',
    batch_download_truck_number: '批量下载箱单追踪号',
    batch_export_waybill_info: '批量下载运单跟踪表',
    merge_download_rcd: '合并下载入仓单',
    batch_download_warehouse_receipt: '批量下载入仓单',
    batch_download_declaration_slip: '批量下载报关底单',
    batch_download_tax_refund: '批量下载退税提单',
    download_warehouse_receipt: '下载入仓单',
  },
  endWaybill: {
    endStandardOrdering: '末端标准下单',
    customsClearanceAndSend: '清关+派送',
    customsClearance: '清关',
    expressDelivery: '快递派送',
    truckDelivery: '卡车派送',
    batchImport: '批量导入',
    title: '合单信息',
    title2: '基本信息',
  },
  smallParcelWaybill: {
    draft: '草稿',
    instock: '待入库',
    instock_cut: '入库扣件',
    outstock: '待出库',
    outstock_cut: '出库扣件',
    departure: '待离港',
    arrival: '待到仓',
    delivery: '待派送',
    signed: '已签收',
    problem: '问题件',
    return: '退件',
  },
  abroadWaybill: {
    WAIT_FOR_CONFIRM: '待确认',
    WAIT_FOR_APPROVAL: '待审批',
    WAIT_FOR_RETURNED: '待退货',
    WAIT_FOR_IN_STORAGE: '待入仓',
    WAIT_FOR_DISPOSE: '待处理',
    FINISH_FOR_DISPOSE: '处理中',
    PART_WAIT_FOR_OUT_STORAGE: '部分待出仓',
    PART_WAIT_FOR_SIGN: '部分待签收',
    WAIT_FOR_OUT_STORAGE: '待出仓',
    WAIT_FOR_SIGN: '待签收',
    ALREADY_FINISH: '已完成',
    WAIT_FOR_LOCK: '待锁单',
    ALREADY_CLOSED: '已关闭',
  },
  customer: {
    email_exist: '邮箱已经存在',
    each_customer_only_can_create_ten_email: '每个客户只能设置10个邮箱',
    email_not_null: '邮箱不能为空',
  },
  finance: {
    __to_audit__: '待审核',
    __approved__: '审核通过',
    __un_audit__: '审核未通过',
  },
  // profile: {
  //   sku: 'SKU管理',
  //   amazon_store: '亚马逊店铺管理',
  //   pickup_address: '常用提货地址',
  //   shipping_address: '常用派送地址',
  //   invoice_title: '发票抬头',
  //   importerInformation: '常用进口商',
  //   senderInformation: '常用发件人',
  //   trackingNotificationSettings: '轨迹通知设置',
  //   overseasWarehouseTrackingNotificationSettings: '海外仓轨迹通知设置',
  //   customerProfileEmailNotification: '客户文件邮件通知'
  // },
  system: {
    guide: '下单指引',
  },
  guide: {
    title: 'FBA快捷下单入库计划装箱单获取指引',
    path: '亚马逊卖家补货系统操作路径',
    approveShipment:
      '亚马逊系统自动分配FBA仓库（Ship to）后，如补货计划确认无误，请点击按钮Approve shipment进入货物包装设置界面。',
  },
  /**
   * 消息
   */
  message: {
    content: '查询内容',
    status: '状态',
    cdate: '创建时间',
    bulkread: '批量已读',
  },
  /**
   * 查价
   */
  price: {
    title: '运费查询',
    loadingPrice: '起运地',
    country: '目的国家',
    weight: '重量',
    volumn: '体积',
    channelAbility: '渠道能力',
    specialProduct: '特殊产品',
    isTaxFarming: '是否包税',
    deliveryTerms: '交货条款',
    query: '查询',
    reset: '重置',
  },
  /**
   * 公共表单组件
   */
  form: {
    query: '查询',
    reset: '重置',
    cancel: '取消',
    save: '保存',
    create: '创建',
  },
  channel: {
    customerSelfInsurance: '客户自行投保',
    waybillNo: '运单号',
    fbaCode: '仓库代码',
    trackNumber: '追踪号',
    loadingPort: '交货地',
    countryId: '目的国家',
    customerId: '公司简称',
    declareNameCn: '中文品名',
    customerActualWeight: '实重(KG)',
    customerTotalPackages: '箱数',
    customerVolume: '体积(CBM)',
    purposeWarehouseType: '目的仓库类型',
    dispatcher: '公司名/个人',
    dispatchLinkMan: '联系人',
    dispatchPhone: '联系电话',
    dispatchEmail: '邮箱',
    dispatchProvince: '州/省',
    dispatchCity: '城市',
    dispatchZipCode: '邮编',
    dispatchAddress: '详细地址1',
    dispatchAddress2: '详细地址2',
    customerDispatchAddress: '常用派送地址',
    saveCustomerDispatchAddress: '保存为常用派送地址',
    dispatchAddressCode: '派送地址',
    additionalAddress: '附加地址',
    deliveryNumber: '入仓号/入仓预约链接',
    deliveryFiles: '派送文件',
    channelCapacity: '渠道能力',
    specialProduct: '特殊产品',
    isTaxFarming: '是否包税',
    exportDelegationCompanyName: '出口委托企业名称',
    exportDelegationCompanyTax: '出口委托企业18位税号',
    deliveryTerms: '交货条款',
    isCustomerDeclaration: '是否报关',
    isNeedSubscribe: '是否需要预约',
    noSubscribe: '无需预约直接送',
    yesSubscribe: '需要预约（请填写任一预约方式，也可多选）',
    inStockChannel: '渠道',
    cabinetNumber: '柜量',
    deliveryType: '派送方式',
    provinceId: '国内分区',
    isPVA: 'Postponed VAT Accounting/增值税递延',
    finalWeight: '预计计费重',
    feightMoney: '预计运费',
    isChinaAustraliaCard: '委托制作中澳证',
    selfDelivered: '交货方式',
    customerFee: '发票申报运费',
    pickup: '九方提货',
    dropoff: '客户自送',
    isBuyInsurance: '购买保险',
    etInStock: '入仓时间',
    customerRemark: '备注',
    yes: '是',
    no: '否',
    selectLabel: '请选择',
    loadingPort_tooltip: '点击填写可快速搜索',
    selectFile: '选取文件',
    channelTips: '渠道附加费和操作说明',
    common_delivery_address: '选择常用派送地址',
    et_inStock_tip:
      '如送货不在预计入仓时间段内，需提前联系对应销售，通知仓库做收货准备',
    selectDate: '选择日期',
    selectDatePeriod: '选择时间段',
    isTaxFarming_tooltips: '您是否选择我司的包税渠道?',
    ddu: '是指您在目的国自有进口商,且在目的国自行支付关税(即：关税到付)；',
    ddp: '是指您在目的国自有或者无进口商,需我司先行垫付关税(即：关税预付)',
    default_ddp: '如您选择我司的包税渠道,则交货条款默认DDP',
    ddu_1: '进口商/收货人在目的国缴税',
    ddp_1: '发货方在非目的国缴税',
    default_ddp_1: '如您选择我司的包税渠道，则交货条款默认DDP',
    customs_declaration_data_upload: '报关资料上传',
    feight_money_tips: '该运费仅供参考，实际收费以我司入仓数据为计费标准',
    customer_declaration_content:
      '是指您指定用某一家具有进出口权的公司做出口申报，能自行提供整套报关单证，且后续要做出口退税的情况。请选择是。如非此情况，请选择否.',
    customs_declaration_materials:
      '客户报关资料已审核，则无法修改是否报关且无法上传报关资料',
    quickly_search: '点击输入可快速搜索',
    referenceNo: '参考号',
    reference_no_tips: '方便您自己用来识别此运单的任意号码.',
    reference_no_require: '请填写英文，数字或者 -，不能超过50位',
    arrivalTotalPackages: '到仓件数',
    dispatch: '派送地址',
    delivery_number: '入仓单号',
    warehouse_register_number: '到仓登记号',
    warehouse: '仓库',
    warehouse_whether_or_not: '是否到仓',
    warehousing_time: '入库时间'
  },
  /**
   * 发件人
   */
  sender: {
    create: '新建发件人公司',
    select: '选择发件人公司',
    companyNameCn: '发件人公司(中)',
    companyNameEn: '发件人公司(英)',
    contact: '联系人',
    phone: '联系电话',
    email: '邮箱',
    address: '发件人英文地址',
    zipCode: '邮编',
    enterpriseCreditCode: '企业信用代码',
    input_companyNameCn: '请填写发件人公司(中)',
    input_companyNameEn: '请填写发件人公司(英)',
    input_contact: '请填写联系人',
    input_phone: '请填写联系电话',
    input_email: '请填写邮箱',
    input_address: '请填写详细地址',
    input_zipCode: '请填写邮编',
    input_enterpriseCreditCode: '请填写企业信用代码',
    input_address: '按门牌号，详细地址，街道，区县，城市，省份，国家的顺序填写',
  },
  /**
   *装箱单
   */
  packing_list: {
    reset: '重置装箱单',
    boxRule: '箱号规则',
    startNum: '起始箱号',
    endNum: '结束箱号',
    selectSku: '选择SKU',
    batchDelte: '批量删除',
    batchEdit: '批量编辑',
    startNum_required: '请填写起始箱号',
    endNum_required: '请填写结束箱号',
    boxNum: '箱号',
    grossWeight: '单箱毛重',
    select_sku: '选择SKU',
    delete_sku: '批量删除',
    batch_edit: '批量编辑',
    cartonNo: '箱号',
    grossWeight: '单箱毛重',
    declareNameCn: '中文品名',
    skuNum: '个数',
    remain: '剩余个数',
    grossWeight: '单箱毛重',
    LWH: '单箱长X宽X高',
    tips1:
      '应进出口国海关要求，装箱单必须做到每箱的箱号要与该箱内所装产品的SKU号码准确对应。',
    tips2:
      '如申报的装箱明细与实际装箱明细不符，在遇到海关查验时，可能产生延误、扣关甚至罚款等责任，将由您自行承担！',
    startNum_tips1: '起始箱号为1，不填写结束箱号，则是填写1箱的数据。',
    startNum_tips2: '起始箱号为1，结束箱号为1，则是填写1箱的数据。',
    startNum_tips3: '起始箱号为1，结束箱号为2，则是填写2箱的数据。',
    skuNum: '总个数',
    inputNum: '请填写数量',
    boxed_num: '装入该箱数量',
    lwh: '长×宽×高(cm)',
  },
  /**
   * 校验规则
   */
  rules_message: {
    loadingPort: '请选择起运地',
    countryId: '请选择目的国家',
    dispatchAddressCode: '请选择派送地址',
    customerActualWeight: '请填写重量,须为数字,可留3位小数',
    customerVolume: '请填写体积',
    customerTotalPackages: '请填写件数',
    purposeWarehouseType: '请选择仓库类型',
    warehouseCompanyName: '请选择仓库公司名称',
    warehouseLinkMan: '请填写联系人',
    warehouseLinkPhone: '请填写联系电话',
    isPVA: '请选择PVA',
    channelCapacity: '请选择渠道能力,至少选择一项',
    specialProduct: '请选择特殊产品,至少选择一项',
    isTaxFarming: '请选择是否包税',
    deliveryTerms: '请选择交货条款',
    isCustomerDeclaration: '请选择是否报关',
    inStockChannel: '请选择渠道',
    deliveryType: '请选择派送方式',
    isNeedSubscribe: '请选择是否需要预约',
    provinceId: '请选择国内分区',
    isChinaAustraliaCard: '请选择是否委托制作中澳证',
    selfDelivered: '请选择提货方式',
    isBuyInsurance: '请选择是否购买保险',
    dispatcher: '请填写公司/个人名',
    dispatchLinkMan: '请填写联系人',
    dispatchPhone: '请填写联系方式',
    dispatchEmail: '请填写邮箱地址,多个邮箱;分开,最多填写4个邮箱',
    dispatchAddress: '请填写地址',
    dispatchAddress2: '请填写地址',
    dispatchProvince: '请填写省',
    dispatchCity: '请填写城市',
    positive_integer: '请填写正整数',
    exportDelegationCompany18Tax: '请输入：18位数字或大写字母组成的数据。',
    number_formate: '须为大于0的数,且最多3位小数',
  },
  /**
   * SKU
   */
  sku: {
    declareNameEn: '英文品名',
    declareNameCn: '中文品名',
    batchImportSku: '批量导入SKU',
    batchExportSku: '批量导出SKU',
    create: '新增SKU',
    edit: '编辑SKU',
    batchCreate: '批量添加SKU',
    brand: '品牌',
    material: '材质',
    purpose: '用途',
    model: '型号',
    measurementUnit: '单位',
    perSuitNum: '每套个数',
    purchasingPrice: '采购单价',
    salePrice: '销售单价',
    salesConnection: 'ASIN/销售链接',
    distributionMaterialCount: '配送料',
    productLotCount: '出品手数料',
    customsCode: '出口海关编码',
    isCharged: '是否带电',
    productAttribute: '产品属性',
    destinationPortCustomsClearanceCode: '目的港海关编码',
    declaredPrice: '申报价格',
    imgUrl: '产品图片',
    sellPriceScreenshot: '销售截图',
    customsDeclaredPriceListHtml: '申报价格',
    incomeScreenshot: '收益截图',
    declared_price_tips: '请正确填写申报价格',
    customs_code_area_tips: '请正确填写目的港清关编码',
  },
  pickUpAddress: {
    title: '提货地址',
    linkMan: '联系人',
    contactWay: '电话',
    provinces: '地址',
    address: '详细地址',
    default: '默认地址',
    defaultValue: '是否默认',
    setDefault: '设为默认',
    add: '新增提货地址',
  },
  shippToAddress: {
    title: '常用派送地址',
    addTitle: '新增常用派送地址',
    customerDeliveryCompany: '公司名',
    personal: '个人',
    customerDeliveryAddressAttn: '联系人',
    customerDeliveryAddressPhone: '联系方式',
    city: '城市',
    state: '州/省',
    zipCode: '邮编',
    address: '地址1',
    address2: '地址2',
    countryId: '国家',
    customerDeliveryAddressPhone: '电话',
    customerDeliveryAddressEmail: '邮箱',
    state_limit: '省州长度不可以大于3',
    size_limit: '最多允许设置100个派送地址',
  },
  /**
   *发票抬头
   */
  invoice: {
    title: '发票抬头',
    invoiceName: '抬头名称',
    type: '类型',
    invoiceBankName: '开户行',
    inviIdentificaNumber: '纳税人识别号',
    invoiceAccount: '银行账户',
    invoicePhone: '电话',
    invoiceReceivePhone: '通知人手机',
    invoiceAddress: '地址',
    invoiceReceiveEmail: '通知人邮箱',
    isdefault: '默认地址',
    setDefault: '设为默认',
  },
  /**
   * 进口商
   */
  importer: {
    title: '进口商信息',
    importerCompany: '公司名',
    importerAttn: '联系人',
    zipCode: '邮编',
    importerZipCode: '邮编',
    importerCountry: '国家',
    importerPhone: '电话',
    importerAddress: '地址',
    importerMail: '邮箱',
    isVatAndEori: '自有VAT和EORI',
    importerCompanyName: '公司名',
    importerLinkMan: '联系人',
    defaultValue: '是否默认',
    select: '选择进口商',
    vat_and_eori: '自有VAT和EORI',
    companyName: '进口商公司名',
    contact: '联系人',
    phone: '联系电话',
    address: '地址',
    mail: '邮箱',
    zipCode: '邮编',
    country: '国家',
    selected_jf_importer: '已选择九方进口商',
    select_jf_importer: '选择九方进口商',
    create: '新增',
    selected: '确定',
    select_country: '请选择国家',
    searchCompany: '公司',
    isRegisterCDS: '是否已注册CDS账号',
  },
  /**
   * 发件人
   */
  shipper: {
    title: '发件人信息',
    shipperCompany: '公司英文全称',
    shipperCompanyCN: '公司中文全称',
    shipperAttn: '联系人',
    shipperPhone: '联系方式',
    shipperAddress: '联系地址',
    shipperZipCode: '邮编',
    shipperEmail: '邮箱',
    shipperEnterpriseCreditCode: '企业信用代码',
    defaultValue: '默认发件人',
    setDefault: '设为默认',
    state_limit:
      'The length of the province and state cannot be greater than 3',
    size_limit: '发件人上限50个',
  },

  /**
   * 预约送仓
   */
  delivery: {
    index: '序号',
    cancel: '取消',
    driverName: '司机姓名',
    driverPhone: '司机手机',
    licensePlate: '车牌',
    number: '入仓单号',
    cnts: '件数（CTNS）',
    volume: '方数（CBM）',
    weight: '重量（KG）',
    name: '入仓仓库',
    appointmentTime: '预约入仓时间',
    arrivalTime: '到仓登记时间',
    arrivalnumber: '到仓登记号',
    isWarehouse: '是否入仓',
    cdate: '创建时间',
    adddelivery: '预约送仓',
    create: '创建预约送仓单',
    warehouse: '交货仓库',
    pring: '打印标签',
  },

  /**
   * 预约送仓（重复名称）
   */
  delivery1: {
    appointmentTime: '预约送仓时间',
  },

  /**
   *提货
   */
  pickup: {
    title: '预约提货时间',
    create: '创建提货单',
    schedule: '预约提货',
    index: '序号',
    sysRemark: '备注',
    waybills: '运单信息',
    cdate: '创建时间',
    arrangementPickupDate: '安排时间',
    scoreGradeName: '评价',
    cancel: '取消',
    waybillNo: '运单号',
    referenceNo: '参考号',
    customerTotalPackages: '预报件数',
    customerActualWeight: '预报重量(KG)',
    customerVolume: '预报体积(CMB)',
    schedulePickupName: '是否已预约',
    takeDeliveryOfGoodsCount: '件数',
    takeDeliveryOfGoodsWeight: '重量(KG)',
    warehouseId: '交货仓库',
    takeDeliveryOfGoodsVolume: '体积(CBM)',
    appointmentPickupDate: '提货时间',
    addNewAdderss: '新增提货地址',
    province: '所在地区',
    address: '地址',
    linkMan: '联系人',
    contactWay: '手机号码',
    save: '保存提货地址',
    cancel: '取消编辑',
    appointmentPickupDate: '预约提货时间',
    pickUpGoodsNum: '提货单号',
    takeDeliveryOfGoodsProvince: '省',
    takeDeliveryOfGoodsCity: '市',
    takeDeliveryOfGoodsArea: '区',
    takeDeliveryOfGoodsStreet: '街道',
    takeDeliveryOfGoodsAddress: '详细地址',
    takeDeliveryOfGoodsLinkMan: '提货联系人',
    takeDeliveryOfGoodsLinkPhone: '联系人手机',
    takeDeliveryOfGoodsLinkPhoneSpare: '备用手机',
    driverName: '司机姓名',
    driverPhone: '司机手机',
    licensePlate: '车牌',
    pickupAddress: '提货地址',
    fold: '收起地址',
    more: '更多地址',
    takeDeliveryOfGoodsLinkPhoneSpare: '备用手机',
    shippwayType: '运单类型',
    is_need_load: '是否需要搬货',
    tips: '温馨提示：如需取消提货，请及时电话通知我司销售人员，如司机已在途中，将产生返空费',
    evaluate: '评价',
    scoreTakeDeliveryOfGood: '提货时效',
    scoreGrade: '服务态度',
    evaluate_tips: '你对这次提货服务还满意吗?',
    one_star: '非常不满意，各方面都差',
    two_star: '不满意，比较差',
    three_star: '一般，还需改善',
    four_star: '比较满意，仍可改善',
    five_star: '非常满意，无可挑剔',
    check_address_error1: '请选择提货地址！',
    check_address_error2: '请填写提货地址！',
    cancel_pickup_confirm: '确定要取消提货吗？',
    submit_appraised_error: '服务态度和提货时效必须评价',
    submit_pickup_error: '请先选择运单',
  },
  port2port: {
    title: 'B2B下单',
    shippingWay: '物流方式',
    AIR: '空运-到港',
    FCL: '海运整柜到港',
    LCL: '海运拼箱到港',
    FCLW: '非FBA海运整柜-到门',
    countryId: '目的国家',
    shipmentPort: '起运港',
    destinationPort: '目的港',
    customerActualWeight: '实重',
    customerTotalPackages: '件数',
    customerVolume: '体积',
    uploadWaybillFile: '文件资料上传',
    upload: '上传',
    purchaseValueCurrency: '币种',
    exportDelegationCompanyName:'出口委托企业名称',
    exportDelegationCompanyTax:'出口委托企业18位税号',
    isCustomerDeclaration: '是否报关',
    isCustomerDeclaration_tips1:
      '是指您指定用某一家具有进出口权的公司做出口申报，能自行提供整套报关单证，且后续要做出口退税的情况。请选择是。如非此情况，请选择否。',
    isCustomerDeclaration_tips2:
      '如您此票货物中有部分货物需用一般贸易报关，其他部分不用一般贸易报关，请选择“部分报关”选项。',
    cabinetNumber: '柜量',
    cabinetType: '柜型',
    isCustomerDeclaration: '报关资料上传',
    selectFile: '选取文件',
    loadingMethod: '装柜方式',
    loadingJF: '九方装柜',
    loadingAddress: '装柜地址',
    customerDelivery: '客户送货',
    loadingCustomer: '客户装柜',
    loadingMethodDesc:
      '九方装柜：九方到客户装柜地址提货，并送货到起运港<br />客户装柜：客户自行在装柜时间内，送货到起运港',
    isBuyInsurance: '购买保险',
    totalPurchasingPrice: '采购总价',
    nameDescription: '品名',
    selectImporter: '选择进口商',
    addImporter: '新增进口商',
    importerCompanyName: '进口商公司名',
    importerLinkMan: '进口商联系人',
    importerPhone: '进口商电话',
    importerZipCode: '进口商邮编',
    vat: '进口商VAT',
    eori: '进口商EORI',
    importerAddress: '进口商地址',
    draft: '提交待确认',
    ship: '完成并提交',
    back: '返回',
    customerRemark: '备注',
    referenceNo: '参考号',
    custoemrSenderId: '发件人公司名(中)',
    shipperCompany: '发件人公司名(英)',
    shipperAttn: '联系人',
    shipperPhone: '电话',
    shipperEmail: '邮箱',
    shipperAddress: '地址',
    masterNumberNotifier: '通知人',
    houseNumberReceiver: '收件人',
    senderAdress: '详细地址(英)',
    senderEnterpriseCreditCode: '企业信用代码',
    senderZipCode: '邮编',
    senderPhone: '电话',
    senderEmail: '邮箱',
    senderLinkMan: '联系人',
    senderCompanyCN: '发件人公司名(中)',
    senderCompany: '发件人公司名(英)',
    selectTimePeriod: '选择时间段',
    selectDate: '选择日期',
    etInStock: '装柜时间',
    fold: '收起地址',
    more: '更多地址',
    addPicupkAddress: '新增提货地址',
    area: '所在地区',
    address: '详细地址',
    linkMan: '联系人',
    contactWay: '手机号码',
    loading_tips:
      '如装柜不在装柜时间段内，需提前联系对应销售，通知九方做收货准备',
    referenceNo_tips: '方便您自己用来识别此运单的任意号码。',
    referenceNo_validate: '请填写英文，数字或者 -，不能超过50位',
    masterNumberNotifier: '通知人',
    houseNumberReceiver: '收件人',
    houseNumberReceiver_formate:
      '公司英文名,公司英文地址,TEL:联系电话,VAT:换行隔开',
    insurance_tips1: '1、不填默认不买保险',
    insurance_tips2:
      '2、如填写货值，则九方买保险，按下单货值购买保险，只赔偿货值90%，理赔时需提供采购发票，哪个低按哪个来核算赔偿金额，赔偿上限为RMB50',
    insurance_terms1: '1、甲方按照产品采购货值的 0.3%向乙方支付保费；',
    insurance_terms2: '2、按照系统下单时提供的产品采购货值赔偿；',
    insurance_terms3:
      '3、无免赔，即按照产品采购货值的100%赔偿，理赔时需提供采购发票，哪个低按哪个来核算赔偿金额',
    insurance_terms4: ' 4、赔偿上限：海运整柜RMB200万/柜',
    loading_method_tips1: '九方装柜：九方到客户装柜地址提货，并送货到起运港',
    loading_method_tips2: '客户装柜：客户自行在装柜时间内，送货到起运港',
    buy_insurance_tips1: 'a 购买为是:',
    buy_insurance_tips2: '1、甲方按照产品采购货值的0.3%向乙方支付保费；',
    buy_insurance_tips3: '2、按照系统下单时提供的产品采购货值赔偿；',
    buy_insurance_tips4:
      '3、无免赔，即按照产品采购货值的100%赔偿，理赔时需提供采购发票，哪个低按哪个来核算赔偿金额；',
    buy_insurance_tips5: '4、赔偿上限：海运整柜RMB200万/柜',
    buy_insurance_tips6: 'b 购买为否',
    buy_insurance_tips7: '1、不填默认不买保险；',
    buy_insurance_tips8:
      '2、如填写货值，则九方买保险，按下单货值购买保险，只赔偿货值90%，理赔时需提供采购发票，哪个低按哪个来核算赔偿金额，赔偿上限为RMB50万/柜。',
    customer_declaration_tips1:
      '是指您指定用某一家具有进出口权的公司做出口申报，能自行提供整套报关单证，且后续要做出口退税的情况。请选择是。如非此情况，请选择否。',
    customer_declaration_tips2:
      '如您此票货物中有部分货物需用一般贸易报关，其他部分不用一般贸易报关，请选择"部分报关"选项。',
    select_sender_company_tips: '已填发件人公司资料将被清空？',
    cabinet_type_tips: '请先填写当前柜型柜量再新增',
    default_buy_insurance: '默认不购买保险！',
    upload_file: '文件上传',
    type: '类型',
    select_type: '请选择类型',
    file_name: '文件名',
    please_input_file_name: '请输入文件名',
    modified_document_number: '修改的文件页码',
    air_heavy_fileplacement: '将文件拖到此处，或',
    click_upload: '点击上传',
    upload_sussecc_save_waybill: '上传文件成功',
    upload_fail: '上传失败',
  },
  detail: {
    title: '运单详情',
    evaluation: '运单评价',
    channel: '渠道信息',
    sender: '发件人信息',
    importer: '进口商信息',
    dispatch: '派送地址信息',
    fee: '费用信息',
    problem: '问题件',
    invoice: '清关发票',
    packing: '装箱单',
    packingListOld: '查看箱单原始数据',
    total: '总计',
    inStockActualWeight: '实重',
    inStockVolume: '体积',
    inStockVolumeWeight: '体积重',
    inStockChargedWeight: '计费重',
    file: '文件列表',
  },
  head: {
    index: '序号',
    opt: '操作',
    costNames: '费用名称',
    totalCost: '金额',
    remain: '未付',
    currency: '币种',
    startNumNo: '箱号',
    trackNumber: '追踪号',
    trackType: '类型',
    weight: '单箱毛重(kg)',
    LWH: '单箱长×宽×高(cm)',
    totalVolum: '体积',
    volumeWeight: '体积重',
    volumeWeights: '计算体积',
    chargedWeight: '计费重',
    sku: 'SKU',
    num: '个数',
    startNumNo: '箱号',
    oldWeight: '单箱毛重(kg)',
    oldLength: '长(cm)',
    oldWidth: '宽(cm)',
    oldHeight: '高(cm)',
    problemType: '问题类型',
    problemDescribe: '问题描述',
    process: '问题进程',
    shipmentId: 'ShipmentID',
    referenceId: 'ReferenceID',
    declareNameEn: '英文品名',
    declareNameCn: '中文品名',
    declareName: '品名',
    brand: '品牌',
    material: '材质',
    purpose: '用途',
    customsCode: '出口海关编码',
    customsClearanceCode: '清关编码',
    asin: 'ASIN/销售链接',
    isCharged: '是否带电',
    model: '型号',
    measurementUnit: '单位',
    perSuitNum: '每套个数',
    purchasingPrice: '采购单价',
    asindeclareValue: 'ASIN售价',
    distributionMaterialCount: '配送料',
    productLotCount: '出品手数料',
    imgUrl: '图片',
    sellpriceScreenshot: '售价截图',
    incomeScreenshot: '收益截图',
    declareValue: '申报单价',
    waybillNo: '运单号',
    referenceNo: '参考号',
    onlineInquiryNo: '询单号',
    statusName: '状态',
    storageLocationName: '入库仓',
    trackNumber2: '追踪号2',
    countryName: '目的国',
    dispatchAddressCode: '派送地址',
    customerChannelMap: '入库渠道',
    totalDeclareValueStr: '申报总额',
    customerActualWeight: '预报实重',
    instockCustomerActualWeight: '入库实重',
    customerVolume: '预报体积',
    instockCustomerVolume: '入库体积',
    customerChargedWeight: '预报计费重',
    instockCustomerChargedWeight: '入库计费重',
    customerTotalPackages: '预报件数',
    inStockTotalPackages: '入库件数',
    inStockTime: '入库时间',
    outStockTime: '出库时间',
    channelCapacity: '渠道能力',
    countryStateName: '国内分区',
    abroadWaybillNo: '海外仓运单',
    bankStatementAmount: '流水金额',
    statementStatusName: '状态',
    rechargePicture: '充值图片',
    customerRemark: '备注',
    cdate: '创建时间',
    accountName: '户名',
    bankName: '开户行',
    address: '开户行地址',
    accountNo: '账号',
    waybillNo: '运单号',
    masterNo: '主单号',
    customerShortName: '公司名称',
    countryName: '退货国家',
    serviceItemName: '服务项目',
    salesmanName: '销售',
    servicesName: '客服',
    cuserName: '创建人',
    seaAirWaybillNo: 'FBA运单号',
    returnCountry: '退货国家',
    serviceArr: '服务项目',
    statusName: '状态',
    salesmanId: '销售',
    servicesId: '客服',
    cuser: '创建人',
    returnBatchIndex: '退货批次',
    returnNo: '退货编号',
    trackNo: '退货追踪号',
    shipmentId: 'Shipment ID',
    cartons: '箱数',
    receiptDate: '仓库签收日期',
    receiptPallets: '签收托盘数',
    receiptCartons: '签收箱数',
    oldsku: '旧FNSKU',
    receiptQuantity: '签收个数',
    receiptCondition: '签收情况（是否有破损）',
    customsCodeListHtml: '目的港清关编码',
    customsDeclaredPriceListHtml: '申报价格',
    accountName: '户名',
    bankName: '开户行',
    address: '开户行地址',
    accountNo: '账号',

    bankStatementAmount: '流水金额',
    statementStatusName: '状态',
    rechargePicture: '充值图片',
    customerRemark: '备注',
    abroadStockAddress: '海外仓地址',
    consignee: '收件人',
    phone: '联系电话',
    productNum: '产品个数',
    weight: '重量',
    storeAddress: '店铺链接',
    fnSku: 'fnSku',
    name: '名称',
    link: '链接',
    download: '下载',
    salePrice: '销售单价',
    returnBatchIndexName: '退货批次',
    cartonNo: '箱号',
    boxNo: '外箱号',
    instockCustomerWeight: '重量',
    instockCustomerLength: '长',
    instockCustomerWidth: '宽',
    instockCustomerHeight: '高',
  },
  abroad: {
    check: '确认当前运单',
    close: '删除当前运单',
    servicesId: '客服',
    salesmanId: '销售',
    masterNo: '主单号',
    waybillNo: '运单号',
    status: '状态',
    return: '打回当前运单',
    edit: '编辑',
    file: '文件列表',
    fileType: '文件类型',
    fileName: '文件名',
    fileOpt: '操作',
    batchNo: '操作批次',
    basic: '基本信息',
    returnCountry: '退货国家',
    customerRemark: '运单备注',
    serviceItemArr: '服务项目',
    OT: '其他',
    HWC: '暂存转运',
    TH: '退货换标',
    shippingWay: '业务类型',
    cargoInfo: '货物信息',
    uploadDialog: '导入货物信息',
    downloadCargoInfo: '导出货物信息',
    change_cargo_info_error: '请填写必填信息',
    trackingInfo: '发货跟踪信息',
    saveStock: '保存仓库地址',
    tracking_error: '请选择FBA仓库地址',
    dispatch_way_error: '请选择派送方式',
    returnBatchIndexName: '退货批次',
    deleteFileTips: '此操作将永久删除该文件, 是否继续?',
    inventory: '库存情况',
    num: '总产品个数',
    boxNum: '总箱数',
    weight: '总重量',
    volume: '总体积',
    export_inventory: '导出库存',
    importInStockInfo_tips:
      '已为您打开文件下载页面，如果页面未跳转，请检查弹出窗口是否被浏览器拦截',
    operationInstruction: '操作指令信息',
    totalAmount0: '总产品预报数量',
    totalAmount1: '总换标数量',
    totalAmount2: '总清点数量',
    totalAmount3: '总检修数量',
    totalAmount4: '总销毁数量',
    operationInstruction_tips: '如需换标，请提供PDF格式标签',
    uploadAbroadWaybillLabelFile: '上传标签文件',
    uploadOperationInstruct: '批量导入信息',
    addReturnBatchIndex: '新增操作批次',
    uploadLabel: '上传标签文件',
    uploadOperationInstructionData: '导入操作指令信息',
    downOperationInstructionData: '导出操作指令信息',
    operationInstruction: '操作指令信息',
    addReturnBatchIndex_confirm_tips: '新增操作批次',
    returnInfo: '退货跟踪信息',
    returnInfoTips:
      '新增或编辑退货跟踪号时，请先导出模板，再导入系统即可，注意不要删掉之前的信息。',
    batchDel: '批量删除',
    selectOpt: '选择操作',
    returnInfoTotalAmount0: '总箱数',
    returnInfoTotalAmount1: '总产品个数',
    returnInfoTotalAmount2: '总签收托盘数',
    returnInfoTotalAmount3: '总签收箱数',
    importReturnInfo: '导入退货追踪信息',
    exportReturnInfo: '导出退货追踪信息',
    returnInfo: '退货追踪信息',
    select_all_tips: '是否操作所选退货信息',
    batch_delete_tips: '请选择要删除的数据',
    enter_select_tips: '请选择已保存过的数据！',
    remark: '备注信息',
    receive: '应收信息',
    confirmBill: '确认账单',
    packingListInfo: '箱单信息',
    exportPackingListInfo: '导出箱单信息',
    exportPackingListLabel: '上传外箱标签文件',
    packingListTotalAmount0: '总箱数',
    packingListTotalAmount1: '总数量',
    packingListTotalAmount2: '总重量',
    confirmPackingList: '确认箱单信息',
    confirm_packing_list_tips: '确认该箱单信息么',
    batchUploadGoodsInfoData: '批量导入货物信息',
  },
  payment: {
    title: '当前欠款',
    repayment: '还款信息',
    bank: '银行汇款(选择以下任何一账号转账还款)',
    tips: '系统升级中请联系销售进行还款',
    error1: '请填写充值金额',
    error2: '请填写正确的数字(只能有2位小数)',
    record: '流水记录',
  },
  hd: {
    remark: '备注信息',
  },
  mail: {
    country: '国家',
    title: '客户文件邮件通知',
    title_oversea: '通知邮箱',
    email: '邮箱',
    typeName: '文件类型',
    fileType: '文件类型',
    cdate: '创建时间',
    isActive: '是否启用',
    isNotice: '是否通知预计时间',
    mail_formate_error: '请填写正确的邮箱',
  },
  common: {
    yes: '是',
    no: '否',
    create: '新增',
    query: '查询',
    edit: '编辑',
    delete: '删除',
    sure: '确定',
    tips: '提示',
    cancel: '取消',
    save: '保存',
    reset: '重置',
    required: '必填',
    opt: '操作',
    select: '选择',
    delete_confirm: '确定要删除吗？',
    upload_limit: '上传文件大小不能超过50MB!',
    upload_file_type: '上传文件只能是jpg/png文件!',
    upload_fail: '上传失败',
    select: 'Select',
    please_select: '请选择',
    please_enter: '请录入',
    illegal_param: '参数格式非法',
    export: '导出',
    submit_confirm: '存为草稿',
    submit_approval: '提交订单',
    fill: '请填写第',
    line_required: '行,必填数据',
    search: '查询',
    upload: '上传',
    upload_image: '上传图片',
    current_image: '当前图片',
    replace_image: '更换图片',
    click_upload: '点击上传',
    file_drag_here: '将文件拖到此处，或',
    sku_name_must_same_file_name: '文件名称需与SKU名称一致',
    index: '序号',
  },
}
